import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from "@material-ui/core";
import { Alert } from "@mui/material";
import Authorize from "components/Authorize";
import { permissionProfiles } from "components/Authorize/permissionProfiles";
import CustomInput from "components/CustomInput";
import { activityStatusReasons } from "features/activity/activityConsts";
import { useGetActivityStatusReasonsQuery } from "features/activity/activitySlice";
import { NoteContent } from "features/notes/NoteContent";
import { useEffect, useState } from "react";
import { useUpdateIssueTrackerStatusMutation } from "../issuesTrackerSlice";
import { issueTrackerStatuses } from "../issueTrackerConsts";

const BulkUpdateTicketStatus = ({ 
    selectedRows,  //Injected by the bulk actions
    issueLookup
}) => {
    
    let { data: statusReasons, error: statusReasonsError, isLoading: isLoadingStatusReasons } = useGetActivityStatusReasonsQuery();
    statusReasons = statusReasons || [];    
    
    const [reasonId, setReasonId] = useState();
    const [open, setOpen] = useState(false);
    const [selectedStatus, setSelectedStatus] = useState();
    const [workorderIssues, setWorkorderIssues] = useState();
    const [required, setRequired] = useState(false);
    const [note, setNote] = useState();

    useEffect(() => {
        let issues = [];
        selectedRows.forEach(id => {
            if (issueLookup?.[id]?.linkedWorkOrders?.length > 0) {
                issues.push(issueLookup[id]);
            }
        })
        setWorkorderIssues(issues);
    }, [selectedRows]);

    const [updateStatus, { isLoading }] = useUpdateIssueTrackerStatusMutation();

    const handleClose = () => {
        setOpen(false);
    }

    const onSave = async (both) => {
        setRequired(both);
        if(both && !reasonId)
        {
            return;
        }
        both ? await updateStatus({ issueIds: selectedRows, status: issueTrackerStatuses.Exception, activityReason: reasonId, note: note?.content }) 
        : await updateStatus({ issueIds: selectedRows, status: issueTrackerStatuses.Exception, activityReason: null, note: null });
        handleClose();
    }

    const onChangeNote = (key, val) => {
        switch (key) {
            case "content":
                setNote({ ...note, content: val });
                break;
            case "viewByClient":
                setNote({ ...note, viewByClient: val })
        }
    }
    
    return (
        <Authorize profile={permissionProfiles.ISSUETRACKER.ISSUE_TRACKER_EDIT}>
            <div>
                <Button
                    variant={'text'}
                    disabled={!selectedRows?.length || isLoading}
                    onClick={() => setOpen(true)}
                    color='primary'>
                    {`Mark as Exception (${selectedRows?.length})`}
                </Button>
            </div>
            <Dialog open={open} onClose={handleClose} >
                <DialogTitle>Close as Exception</DialogTitle>
                <DialogContent>
                    {/* for now we're limiting the bulk update to only Exception status */}

                    {`Are you sure you want to close this ticket as an Exception?`} 
                    {!!workorderIssues?.length && ( <>
                        <div style={{ paddingTop: '1em'}}>{'Would you also like to update the linked workorders to the Exception status?'}</div>                         
                            <Grid item xs={8} style={{ padding: '1em 0 1em 0'}}>
                                {(!reasonId && required) && 
                                <Grid style={{ paddingBottom: '1em'}}><Alert severity="warning">Please select a reason for the exception</Alert></Grid>}

                                <CustomInput
                                    id="reasonId"
                                    label="Activity Exception Reason"
                                    elementType="dropdown"
                                    values={statusReasons}
                                    value={reasonId}
                                    required={required}
                                    showEmpty={true}
                                    onChange={val => setReasonId(val)}
                                />
                            </Grid>
                    </>)}
                    {/* <StatusSelector status={selectedStatus} onChange={(val) => setSelectedStatus(val)} filter /> */}
                    
                    {reasonId == activityStatusReasons.Other && <div>
                        {(!note?.content?.replace(/<[^>]+>/g, '')?.trim()) ?
                            <div style={{paddingBottom: '.5em'}}><Alert severity="error">Note is required</Alert></div> : null
                        }
                        <NoteContent content={note?.content} viewByClient={note?.viewByClient} onChange={onChangeNote} />
                    </div>}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Cancel
                    </Button>
                    {!!workorderIssues?.length &&<Button onClick={() => onSave(true)} color="primary" disabled={reasonId == activityStatusReasons.Other && (!note?.content?.replace(/<[^>]+>/g, '')?.trim())}>
                        Update both
                    </Button>}
                    <Button onClick={() => onSave(false)} color="primary">
                        {!!workorderIssues?.length ? 'Just update ticket' : 'Save'}
                    </Button>
                </DialogActions>
            </Dialog>
        </Authorize>
    )
}

export default BulkUpdateTicketStatus;